import React, { useContext, useEffect, useState } from "react";
//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
//images
import { useDispatch, useSelector } from "react-redux";
import { getProductsFunc } from "../../../store/custom-actions/products-actions/GetProductsSlicer";
import Check from "./../../../images/vector/check.png";
import Bookmarks from "./../../../images/vector/bookmarks.png";
import Bulb from "./../../../images/vector/bulb.png";
import { getUsersFunc } from "../../../store/custom-actions/users-actions/GetUsersSlicer";
import { getCategoriesFunc } from "../../../store/custom-actions/categories-actions/GetCategoriesSlicer";
import { getSiteDataFunc } from "../../../store/custom-actions/settings-actions/dahsboard/GetSiteDataSlicer";
import SpinnerLoading from "../spinner-loading/SpinnerLoading";
import MonthlyOrdersChart from "./site-charts/MonthlyOrders";
import EmptyData from "../empty-data/EmptyData";
import TotalMonthlyIncomeChart from "./site-charts/TotalMonthlyIncomeChart";
import MonthlyNetIncomeChart from "./site-charts/MonthlyNetIncomeChart";
import ProductsSoldDonut from "./site-charts/ProductsSoldDonut";
import LowStockProductsTable from "./site-charts/LowStockProductsTable";
import LastPendingOrdersTable from "./site-charts/LastPendingOrdersTable";
import { getSiteSetting } from "../../../utils/getSiteSetting";
import { formatCurrency } from "../../../utils/formatCurrency";

function RightIcon() {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 0.25H4C3.00544 0.25 2.05161 0.645088 1.34835 1.34835C0.645088 2.05161 0.25 3.00544 0.25 4V19C0.25 19.9946 0.645088 20.9484 1.34835 21.6517C2.05161 22.3549 3.00544 22.75 4 22.75H19C19.9946 22.75 20.9484 22.3549 21.6517 21.6517C22.3549 20.9484 22.75 19.9946 22.75 19V4C22.75 3.00544 22.3549 2.05161 21.6517 1.34835C20.9484 0.645088 19.9946 0.25 19 0.25ZM16.875 8.5125L11.1625 16.0125C11.0461 16.1638 10.8965 16.2864 10.7253 16.3709C10.5542 16.4554 10.3659 16.4995 10.175 16.5C9.98513 16.501 9.79753 16.4588 9.62643 16.3765C9.45532 16.2942 9.30522 16.174 9.1875 16.025L6.1375 12.1375C6.03655 12.0078 5.96212 11.8595 5.91848 11.7011C5.87484 11.5426 5.86283 11.3772 5.88314 11.2141C5.90346 11.051 5.95569 10.8935 6.03687 10.7506C6.11804 10.6077 6.22657 10.4822 6.35625 10.3812C6.61815 10.1774 6.95032 10.0859 7.27968 10.1269C7.44276 10.1472 7.60025 10.1994 7.74314 10.2806C7.88604 10.3618 8.01155 10.4703 8.1125 10.6L10.15 13.2L14.875 6.95C14.9751 6.81868 15.1002 6.70836 15.2429 6.62536C15.3857 6.54235 15.5434 6.48828 15.7071 6.46622C15.8707 6.44417 16.0371 6.45457 16.1968 6.49682C16.3564 6.53908 16.5062 6.61237 16.6375 6.7125C16.7688 6.81263 16.8791 6.93765 16.9621 7.08042C17.0451 7.22318 17.0992 7.3809 17.1213 7.54456C17.1433 7.70823 17.1329 7.87463 17.0907 8.03427C17.0484 8.19392 16.9751 8.34368 16.875 8.475V8.5125Z"
          fill="var(--secondary)"
        />
      </svg>
    </>
  );
}

function BookIcon() {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 21 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3201 4.65852H2.86175C2.35544 4.6591 1.87003 4.8592 1.51201 5.21494C1.15399 5.57068 0.952605 6.053 0.952026 6.55609V24.5829C0.952032 24.7573 1.00037 24.9282 1.09175 25.077C1.18312 25.2259 1.31399 25.3468 1.47 25.4266C1.626 25.5063 1.80111 25.5418 1.97609 25.5292C2.15108 25.5166 2.31918 25.4563 2.46195 25.355L8.5901 21.005L14.72 25.355C14.8628 25.4563 15.0309 25.5166 15.2058 25.5292C15.3808 25.5418 15.5559 25.5063 15.7119 25.4265C15.8679 25.3468 15.9988 25.2258 16.0901 25.077C16.1815 24.9282 16.2298 24.7572 16.2298 24.5829V6.55609C16.2292 6.053 16.0278 5.57068 15.6698 5.21494C15.3118 4.8592 14.8264 4.6591 14.3201 4.65852V4.65852Z"
          fill="#21262E"
        />
        <path
          d="M18.1395 0.863403H5.72635C5.4731 0.863403 5.23023 0.963364 5.05116 1.14129C4.87209 1.31923 4.77148 1.56055 4.77148 1.81218C4.77148 2.06382 4.87209 2.30514 5.05116 2.48307C5.23023 2.661 5.4731 2.76096 5.72635 2.76096H18.1395V20.7878C18.1395 21.0394 18.2401 21.2808 18.4192 21.4587C18.5983 21.6366 18.8412 21.7366 19.0944 21.7366C19.3476 21.7366 19.5905 21.6366 19.7696 21.4587C19.9487 21.2808 20.0493 21.0394 20.0493 20.7878V2.76096C20.0487 2.25788 19.8473 1.77556 19.4893 1.41982C19.1313 1.06408 18.6459 0.863979 18.1395 0.863403V0.863403Z"
          fill="#21262E"
        />
      </svg>
    </>
  );
}

function BulbIcon() {
  return (
    <>
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4999 7.13426C12.1639 7.13426 10.8617 7.55464 9.7778 8.33585C8.69393 9.11705 7.88334 10.2195 7.46084 11.487C7.03834 12.7545 7.02536 14.1228 7.42373 15.3981C7.82209 16.6733 8.61162 17.791 9.68047 18.5926V23.6852C9.68047 24.3605 9.94874 25.0082 10.4263 25.4857C10.9038 25.9632 11.5514 26.2315 12.2268 26.2315H14.7731C15.4484 26.2315 16.096 25.9632 16.5736 25.4857C17.0511 25.0082 17.3194 24.3605 17.3194 23.6852V18.5926C18.3882 17.791 19.1777 16.6733 19.5761 15.3981C19.9745 14.1228 19.9615 12.7545 19.539 11.487C19.1165 10.2195 18.3059 9.11705 17.222 8.33585C16.1382 7.55464 14.836 7.13426 13.4999 7.13426ZM13.4999 5.86111C13.8376 5.86111 14.1614 5.72698 14.4002 5.48822C14.6389 5.24946 14.7731 4.92563 14.7731 4.58797V2.04167C14.7731 1.70401 14.6389 1.38018 14.4002 1.14142C14.1614 0.902659 13.8376 0.768524 13.4999 0.768524C13.1622 0.768524 12.8384 0.902659 12.5997 1.14142C12.3609 1.38018 12.2268 1.70401 12.2268 2.04167V4.58797C12.2268 4.92563 12.3609 5.24946 12.5997 5.48822C12.8384 5.72698 13.1622 5.86111 13.4999 5.86111ZM24.9582 12.2269H22.4119C22.0743 12.2269 21.7505 12.361 21.5117 12.5998C21.2729 12.8385 21.1388 13.1623 21.1388 13.5C21.1388 13.8377 21.2729 14.1615 21.5117 14.4003C21.7505 14.639 22.0743 14.7731 22.4119 14.7731H24.9582C25.2959 14.7731 25.6197 14.639 25.8585 14.4003C26.0973 14.1615 26.2314 13.8377 26.2314 13.5C26.2314 13.1623 26.0973 12.8385 25.8585 12.5998C25.6197 12.361 25.2959 12.2269 24.9582 12.2269ZM4.58788 12.2269H2.04158C1.70392 12.2269 1.38009 12.361 1.14133 12.5998C0.902567 12.8385 0.768433 13.1623 0.768433 13.5C0.768433 13.8377 0.902567 14.1615 1.14133 14.4003C1.38009 14.639 1.70392 14.7731 2.04158 14.7731H4.58788C4.92554 14.7731 5.24937 14.639 5.48813 14.4003C5.72689 14.1615 5.86102 13.8377 5.86102 13.5C5.86102 13.1623 5.72689 12.8385 5.48813 12.5998C5.24937 12.361 4.92554 12.2269 4.58788 12.2269ZM7.97445 6.39584L6.14112 4.58797C5.89294 4.35329 5.5617 4.22682 5.22027 4.23637C4.87884 4.24592 4.55519 4.39071 4.32051 4.63889C4.08584 4.88707 3.95937 5.21831 3.96892 5.55974C3.97847 5.90117 4.12326 6.22482 4.37144 6.45949L6.20477 8.22917C6.3278 8.34797 6.47351 8.44076 6.63319 8.50201C6.79287 8.56325 6.96325 8.5917 7.13417 8.58565C7.30567 8.585 7.47527 8.5497 7.63279 8.48188C7.79031 8.41406 7.9325 8.31511 8.05084 8.19098C8.2781 7.94248 8.39765 7.61407 8.38334 7.27763C8.36902 6.94119 8.222 6.62413 7.97445 6.39584ZM22.6538 4.65162C22.4153 4.4145 22.0926 4.2814 21.7563 4.2814C21.4199 4.2814 21.0972 4.4145 20.8587 4.65162L19.0254 6.39584C18.7882 6.63438 18.6551 6.95706 18.6551 7.29341C18.6551 7.62975 18.7882 7.95244 19.0254 8.19098C19.1437 8.31511 19.2859 8.41406 19.4434 8.48188C19.6009 8.5497 19.7705 8.585 19.942 8.58565C20.2698 8.58435 20.5845 8.45666 20.8205 8.22917L22.6538 6.45949C22.7732 6.34114 22.8679 6.20033 22.9325 6.04518C22.9972 5.89004 23.0304 5.72363 23.0304 5.55556C23.0304 5.38749 22.9972 5.22108 22.9325 5.06594C22.8679 4.91079 22.7732 4.76998 22.6538 4.65162Z"
          fill="var(--primary)"
        />
      </svg>
    </>
  );
}
function DeliveryIcon() {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54 24H48V16a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h1.4a7 7 0 0 0 13.2 0h30.8a7 7 0 1 0 7-7v-8a2 2 0 0 0-2-2h-4v-4a2 2 0 0 0-2-2zM6 46V18h38v26H6zm48 0h-4v-8h4v8zm-26-8h4v4h-4v-4z"
          fill="var(--primary)"
        />
        <circle cx="15" cy="50" r="5" fill="var(--primary)" />
        <circle cx="49" cy="50" r="5" fill="var(--primary)" />
      </svg>
    </>
  );
}
function PendingIcon() {
  return (
    <>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 1.75C5.97754 1.75 1.75 5.97754 1.75 11.5C1.75 17.0225 5.97754 21.25 11.5 21.25C17.0225 21.25 21.25 17.0225 21.25 11.5C21.25 5.97754 17.0225 1.75 11.5 1.75ZM11.5 19.25C7.20183 19.25 3.75 15.7982 3.75 11.5C3.75 7.20183 7.20183 3.75 11.5 3.75C15.7982 3.75 19.25 7.20183 19.25 11.5C19.25 15.7982 15.7982 19.25 11.5 19.25ZM12.375 11.5H7.875C7.39175 11.5 7 11.8917 7 12.375C7 12.8583 7.39175 13.25 7.875 13.25H12.375C12.8583 13.25 13.25 12.8583 13.25 12.375V7.875C13.25 7.39175 12.8583 7 12.375 7C11.8917 7 11.5 7.39175 11.5 7.875V11.5H12.375Z"
          fill="var(--primary)"
        />
      </svg>
    </>
  );
}
const ProductsIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 2.75H17.25C18.2165 2.75 19.1296 3.14509 19.7929 3.80835C20.4562 4.47161 20.8513 5.3848 20.8513 6.35126L20.85 16.6488C20.85 17.6152 20.4549 18.5284 19.7916 19.1916C19.1284 19.8549 18.2152 20.25 17.2487 20.25H5.75126C4.7848 20.25 3.87161 19.8549 3.20835 19.1916C2.54509 18.5284 2.15 17.6152 2.15 16.6488V6.35126C2.15 5.3848 2.54509 4.47161 3.20835 3.80835C3.87161 3.14509 4.7848 2.75 5.75126 2.75ZM5.75 0.75C4.22208 0.75 2.75 1.22208 1.79289 2.17895C0.835786 3.13581 0.364098 4.6084 0.364098 6.1364V16.864C0.364098 18.392 0.835786 19.8646 1.79289 20.8215C2.75 21.7783 4.22208 22.25 5.75 22.25H17.25C18.7779 22.25 20.25 21.7783 21.2071 20.8215C22.1642 19.8646 22.6359 18.392 22.6359 16.864V6.1364C22.6359 4.6084 22.1642 3.13581 21.2071 2.17895C20.25 1.22208 18.7779 0.75 17.25 0.75H5.75ZM8 12H11C11.2652 12 11.5196 12.1054 11.7071 12.2929C11.8946 12.4804 12 12.7348 12 13V16C12 16.2652 11.8946 16.5196 11.7071 16.7071C11.5196 16.8946 11.2652 17 11 17H8C7.73478 17 7.48043 16.8946 7.29289 16.7071C7.10536 16.5196 7 16.2652 7 16V13C7 12.7348 7.10536 12.4804 7.29289 12.2929C7.48043 12.1054 7.73478 12 8 12ZM12 7H15C15.2652 7 15.5196 7.10536 15.7071 7.29289C15.8946 7.48043 16 7.73478 16 8V11C16 11.2652 15.8946 11.5196 15.7071 11.7071C15.5196 11.8946 15.2652 12 15 12H12C11.7348 12 11.4804 11.8946 11.2929 11.7071C11.1054 11.5196 11 11.2652 11 11V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z"
      fill="var(--secondary)"
    />
  </svg>
);

const Home = () => {
  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);
  const site_global_currency = getSiteSetting("site_global_currency");
  const users_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/users`;
  const siteData_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard`;
  const [productsList, setProductsList] = useState([]);
  const dispatch = useDispatch();
  const { loading: getProductsLoading, data } = useSelector(
    (state) => state.getAllProductsSlicer
  );
  const { loading: getSiteDataLoading, data: siteDataFromApi } = useSelector(
    (state) => state.getSiteDataSlicer
  );
  useEffect(() => {
    const getSiteData = () => {
      dispatch(getSiteDataFunc(siteData_API_URL));
    };
    getSiteData();
  }, []);
  const dataList = [
    {
      classChange: "bg-secondary",
      image: Check,
      imgClass: "",
      title: "All Products",
      number: getProductsLoading ? "loading.." : productsList.length,
      svgicon: <ProductsIcon />,
    },
    {
      image: Bookmarks,
      imgClass: "bookmarks",
      title: "All Users",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi && siteDataFromApi.users_count,
      svgicon: <BookIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bulb,
      imgClass: "bulb",
      title: "Active Orders",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi && siteDataFromApi.orders_active_count,
      svgicon: <BulbIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bookmarks,
      imgClass: "bookmarks",
      title: "Orders in Delivery",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi && siteDataFromApi.orders_delivery_count,
      svgicon: <DeliveryIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bulb,
      imgClass: "bulb",
      title: "Pending Orders",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi && siteDataFromApi.orders_pending_count,
      svgicon: <PendingIcon />,
    },
    {
      classChange: "bg-secondary",
      image: Check,
      imgClass: "bulb",
      title: "Completed Orders",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi && siteDataFromApi.orders_complete_count,
      svgicon: <RightIcon />,
    },
    {
      image: Bookmarks,
      imgClass: "bookmarks",
      title: "Refund Orders",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && Number(siteDataFromApi.orders_refund_count ?? 0),
      svgicon: <BookIcon />,
    },
    {
      classChange: "bg-secondary",
      image: Check,
      imgClass: "bulb",
      title: "Total Tax Fee",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_tax_fee ?? 0)),
      svgicon: <RightIcon />,
    },
    {
      image: Bookmarks,
      imgClass: "bookmarks",
      title: "Total Sale",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_price ?? 0)),
      svgicon: <BookIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bulb,
      imgClass: "bulb",
      title: "Total Revenue",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_revenue ?? 0)),
      svgicon: <RightIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bulb,
      imgClass: "bulb",
      title: "Total Refund",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_refund ?? 0)),
      svgicon: <PendingIcon />,
    },
    {
      classChange: "bg-secondary",
      image: Check,
      imgClass: "bulb",
      title: "Total Shipping",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_shipping ?? 0)),
      svgicon: <RightIcon />,
    },
    {
      classChange: "bg-primary",
      image: Bulb,
      imgClass: "bulb",
      title: "Total Discounts",
      number: getSiteDataLoading
        ? "loading.."
        : siteDataFromApi != null && formatCurrency(Number(siteDataFromApi.orders_total_discount ?? 0)),
      svgicon: <BulbIcon />,
    },
  ];
  useEffect(() => {
    const getProducts = async () => {
      dispatch(getProductsFunc()).then((result) => console.log(result));
    };
    getProducts();
  }, []);
  useEffect(() => {
    data && setProductsList(data);
  }, [data]);
  useEffect(() => {
    const getUsers = async () => {
      try {
        dispatch(getUsersFunc(users_API_URL));
      } catch (error) {
        console.log(error);
      }
    };
    getUsers();
  }, []);
  useEffect(() => {
    const getCategoriesData = async () => {
      try {
        dispatch(getCategoriesFunc());
      } catch (error) {
        console.log(error);
      }
    };
    getCategoriesData();
  }, []);
  return (
    <>
      {getSiteDataLoading ? (
        <SpinnerLoading />
      ) : siteDataFromApi ? (
        <div className="row g-3">
          {/* 1. Stats: 2 cols mobile, 3 tablet, 4 desktop */}
          <div className="col-12">
            <div className="row g-3">
              {dataList.map((item, ind) => (
                <div
                  className="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-3"
                  key={ind}
                >
                  <div className={`dlab-cource h-100 ${item.classChange || ""}`}>
                    <div className="d-flex align-items-center">
                      <span className="course-icon">{item.svgicon}</span>
                      <div className="ms-2 flex-grow-1 min-w-0">
                        <h4 className="mb-0 text-truncate small">{item.number}</h4>
                        <span className="small text-nowrap text-truncate d-block">{item.title}</span>
                      </div>
                    </div>
                    <img
                      src={item.image}
                      alt=""
                      className={item.imgClass}
                      aria-hidden
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 2. Monthly Orders - full width */}
          <div className="col-12">
            <div className="card score-active h-100">
              <div className="card-header border-0 flex-wrap">
                <h4 className="text-primary mb-0">Monthly Orders</h4>
              </div>
              <div className="card-body pb-1 custome-tooltip style-1 py-0 overflow-auto">
                <MonthlyOrdersChart
                  ordersList={siteDataFromApi.monthly_orders_count || []}
                  monthlyList={siteDataFromApi.month_list || []}
                />
              </div>
            </div>
          </div>

          {/* 3. Monthly Income + Monthly Net Income - side by side on lg */}
          <div className="col-12 col-lg-6">
            <div className="card score-active h-100">
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="text-primary mb-0">Monthly Income</h4>
                <ul className="d-flex align-items-center gap-2 flex-wrap mb-0 mt-1 mt-md-0 ms-md-auto">
                  <li className="small">
                    <span className="text-secondary">{site_global_currency}</span> Currency
                  </li>
                  <li className="small">
                    <i className="fa-solid fa-money-bill-wave text-secondary opacity-75 me-1" />
                    Monthly Income
                  </li>
                </ul>
              </div>
              <div className="card-body pb-1 custome-tooltip pt-0 overflow-auto">
                <TotalMonthlyIncomeChart
                  incomeList={siteDataFromApi.total_monthly_income || []}
                  monthlyList={siteDataFromApi.month_list || []}
                  currency={site_global_currency}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="card score-active h-100">
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="text-primary mb-0">Monthly Net Income</h4>
                <ul className="d-flex align-items-center gap-2 flex-wrap mb-0 mt-1 mt-md-0 ms-md-auto">
                  <li className="small">
                    <span className="text-secondary">{site_global_currency}</span> Currency
                  </li>
                  <li className="small">
                    <i className="fa-solid fa-money-bill-wave text-secondary opacity-75 me-1" />
                    Monthly Net Income
                  </li>
                </ul>
              </div>
              <div className="card-body pb-1 custome-tooltip style-1 py-0 overflow-auto">
                <MonthlyNetIncomeChart
                  netIncomeList={siteDataFromApi.net_monthly_income || []}
                  monthlyList={siteDataFromApi.month_list || []}
                />
              </div>
            </div>
          </div>

          {/* 4. Donuts: Top 5 + Bottom 5 - side by side on md */}
          <div className="col-12 col-md-6">
            <div className="card score-active h-100">
              <div className="card-header border-0">
                <h4 className="text-primary mb-0">Top 5 Products Sold</h4>
              </div>
              <div className="card-body overflow-auto">
                <ProductsSoldDonut
                  title="Top 5"
                  data={siteDataFromApi.top_5_products_sold || []}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card score-active h-100">
              <div className="card-header border-0">
                <h4 className="text-primary mb-0">Bottom 5 Products Sold</h4>
              </div>
              <div className="card-body overflow-auto">
                <ProductsSoldDonut
                  title="Bottom 5"
                  data={siteDataFromApi.bottom_5_products_sold || []}
                />
              </div>
            </div>
          </div>

          {/* 5. Tables: Low Stock + Last Pending Orders - side by side on lg */}
          <div className="col-12 col-lg-6">
            <div className="card score-active h-100">
              <div className="card-header border-0">
                <h4 className="text-primary mb-0">Low Stock Products</h4>
              </div>
              <div className="card-body overflow-auto">
                <LowStockProductsTable
                  data={siteDataFromApi.low_stock_products || []}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="card score-active h-100">
              <div className="card-header border-0">
                <h4 className="text-primary mb-0">Last 5 Pending Orders</h4>
              </div>
              <div className="card-body overflow-auto">
                <LastPendingOrdersTable
                  data={siteDataFromApi.last_5_pending_orders || []}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <EmptyData />
      )}
    </>
  );
};
export default Home;
